var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.476 42.694l-16.52-16.62c1.633-4.202.726-9.133-2.724-12.603-3.63-3.653-9.077-4.384-13.434-2.375l7.806 7.854-5.446 5.48-7.988-7.854c-2.179 4.383-1.271 9.863 2.36 13.516 3.45 3.47 8.351 4.383 12.527 2.74l16.52 16.62c.727.73 1.816.73 2.542 0l4.176-4.2c.907-.731.907-2.01.181-2.558z",
    fill: "#E3B05F"
  })));
}

export default SvgBuild;